import { render } from "./FriendsModal.vue?vue&type=template&id=9c605cec&scoped=true&ts=true"
import script from "./FriendsModal.vue?vue&type=script&lang=ts"
export * from "./FriendsModal.vue?vue&type=script&lang=ts"

import "./FriendsModal.vue?vue&type=style&index=0&id=9c605cec&scoped=true&lang=css"

import exportComponent from "/home/bese/Documents/partybeast/party-beast-prototype/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c605cec"]])

export default __exports__